import { IsoDateTime,success,Uuid } from "@secretaa/http-contract";
import { z } from "zod";
import { Scope,Profile } from "./ai-model-control.ts";
import { AiHandoffResult,checkCoreHandoffFanIn } from "./work-os/handoff-result.ts";
import { Identity,Version,sameScope } from "./work-os/primitives.ts";
export const Receipt=z.object({...Identity,version:z.literal(1),parentAiRunId:Uuid,rootAiRunId:Uuid,parentRevision:Version,acceptedAt:IsoDateTime,results:z.array(AiHandoffResult).min(1).max(4)}).strict().superRefine((r,ctx)=>{
 if(checkCoreHandoffFanIn(r.results.map(x=>x.handoffRef),r.results).length || r.results.some(x=>x.parentAiRunId!==r.parentAiRunId || !sameScope(x.scope,r.scope) || Date.parse(x.completedAt)>Date.parse(r.acceptedAt)))ctx.addIssue({code:"custom",message:"FAN_IN_RECEIPT_INVALID"});
});
export type Receipt=z.infer<typeof Receipt>;
export const Command=z.object({scope:Scope,profile:Profile,expectedRunRevision:Version}).strict();
export type Command=z.infer<typeof Command>;
const base={scope:Scope,profile:Profile,runRevision:Version};
const counts={total:z.number().int().min(1).max(4),completed:z.number().int().min(0).max(4)};
export const Result=z.discriminatedUnion("state",[
 z.object({...base,state:z.literal("NO_CHILDREN")}).strict(),
 z.object({...base,...counts,state:z.literal("WAITING")}).strict(),
 z.object({...base,...counts,state:z.literal("BLOCKED"),reason:z.enum(["CHILD_FAILED","CHILD_INTERRUPTED","CHILD_OUTPUT_UNAVAILABLE"])}).strict(),
 z.object({...base,state:z.literal("ACCEPTED"),receipt:Receipt}).strict(),
]).superRefine((r,ctx)=>{
 if(("completed" in r && r.completed>r.total) || (r.state==="ACCEPTED" && (r.receipt.parentAiRunId!==r.scope.aiRunId || r.receipt.scope.workspaceId!==r.scope.workspaceId || r.receipt.parentRevision!==r.runRevision)))ctx.addIssue({code:"custom",message:"FAN_IN_RESULT_INVALID"});
});
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const PATH="/api/internal/v1/ai-preparation-fan-in";
export const CONTRACT_VERSION="1.0.0";
